export const getCassisData = () => ({
  name: "Cassis",
  region: "Provence",
  country: "France",
  description: "Cassis est une petite appellation de Provence, réputée pour ses vins blancs frais et minéraux, ainsi que ses rosés délicats.",
  type: "subregion",
  area: "210 ha",
  production: "10,000 hectolitres",
  mapAreas: [
    { region: "Cassis", x: 5.55, y: 43.22, color: "#4B164C", size: 2 }
  ],
  characteristics: {
    climate: "Climat méditerranéen, influence maritime",
    soil: "Sols calcaires, caillouteux",
    viticulture: "Viticulture traditionnelle, rendements faibles"
  },
  wineStyles: {
    red: "Vins rouges rares, souples et fruités",
    white: "Vins blancs frais, minéraux et aromatiques",
    rose: "Rosés délicats et fruités"
  },
  history: "La viticulture à Cassis remonte à l'Antiquité. L'appellation est reconnue pour la qualité de ses blancs.",
  foodPairing: "Poissons, fruits de mer, cuisine méditerranéenne, fromages frais",
  grapeVarieties: {
    white: ["Marsanne", "Clairette", "Ugni Blanc", "Sauvignon Blanc"],
    red: ["Grenache", "Mourvèdre", "Cinsault"],
    rose: ["Grenache", "Cinsault", "Mourvèdre"]
  },
  subregions: {}
}); 